<template>
  <div class="content">
    <vue-particles
      style="height: 100vh"
      color="#dedede"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#dedede"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="8"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
    ></vue-particles>

    <div class="login">
      <img class="imgBg" src="../image/login.png" alt style="opacity: 0.8" />
      <div class="title_l">喜礼门店管理系统</div>
      <el-input v-model="account" placeholder="账号" class="account"></el-input>
      <el-input
        v-model="password"
        placeholder="密码"
        show-password
        class="password"
      ></el-input>
      <el-input
        v-model="password"
        placeholder="密码"
        show-password
        class="password"
      ></el-input>
      <div class="rememberBtn">
        <el-checkbox v-model="passwordChecked">记住密码</el-checkbox>
      </div>
      <el-button
        type="primary"
        class="loginBtn"
        @click="loginBtn"
        v-loading.fullscreen.lock="fullscreenLoading"
        >登录</el-button
      >
    </div>
  </div>
</template>

<script>
// import { Dialog } from "vant";
import { login } from "../services/userServices";
// import md5 from "js-md5";
export default {
  components: {},
  created() {
     //1记住密码  0不记住密码
    if (localStorage.getItem("passwordChecked") == 1) {
      this.passwordChecked = true;
      // 密码回显
      var loginForm = JSON.parse(localStorage.getItem("loginForm"));
      // console.log(loginForm);
      if (loginForm !== null) {
        this.account = loginForm.account;
        this.password = loginForm.password;
      }
    } else {
      this.passwordChecked = false;
    }

    // var _this = this;
    // document.onkeydown = function () {
    //   //按下回车提交
    //   let key = window.event.keyCode;
    //   //事件中keycode=13为回车事件
    //   if (key == 13) {
    //     _this.loginBtn();
    //   }
    // };
  },
  data() {
    return {
      fullscreenLoading: false,
      account: "",
      password: "",
      passwordChecked: "",
    };
  },
   watch: {
    // 记住密码监听
    passwordChecked(value) {
      console.log(value);
      if (this.passwordChecked) {
        // this.$message.success("记住密码");
        //将用户数据存到localStorage 长期有效 （cooking不设置时效关闭浏览器就消失了 设置才长期有效）
        localStorage.setItem("passwordChecked", 1);
        var loginForm = {
          account: this.account,
          password: this.password
        };
        localStorage.setItem("loginForm", JSON.stringify(loginForm));
      } else {
        // this.$message.success("取消");
        localStorage.setItem("passwordChecked", 0);
        localStorage.removeItem("loginForm");
      }
    }
  },
  methods: {
    loginBtn() {
      this.fullscreenLoading = true;
      // var password = md5(this.password);
      var password = this.password;
      login(this.account, password).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          console.log(res);
          this.$store.commit("updataRole", res.data.data); //将用户数据存到vuex
          console.log(this.$store.state);
          setTimeout(() => {
            this.fullscreenLoading = false;
            if (this.$store.state.supUser.role_id == 0) {
              this.$router.push({ name: "VipCard" });
            } else {
              this.$router.push({ name: "VipCard" });
            }
          }, 1000);
        } else {
          this.$message.error(res.data.message);
          setTimeout(() => {
            this.fullscreenLoading = false;
          }, 1000);
        }
      });
      //    记住密码监听
      if (this.passwordChecked) {
        // this.$message.success("记住密码");
        //将用户数据存到localStorage 长期有效 （cooking不设置时效关闭浏览器就消失了 设置才长期有效）
        localStorage.setItem("passwordChecked", 1);
        var loginForm = {
          account: this.account,
          password: this.password
        };
        localStorage.setItem("loginForm", JSON.stringify(loginForm));
      } else {
        // this.$message.success("取消");
        localStorage.setItem("passwordChecked", 0);
        localStorage.removeItem("loginForm");
      }
    },

    open() {
      this.$message({
        message: "登录成功",
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
body {
  background: #fff8f8;
}
.content {
  width: 100%;
  height: 100vh;
  /* max-width: 1500px; */
  margin: 0 auto;
  background: rgb(0, 0, 0);
  position: relative;
  /* outline: 1px solid red; */
}
.login {
  /* outline: 1px solid red; */
  position: absolute;
  width: 50%;
  min-width: 550px;
  display: block;
  /* margin: 0 auto; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}
.imgBg {
  width: 100%;
  display: block;
}
.title_l {
  position: absolute;
  top: 25%;
  right: 22%;
  /* width: 28%; */
  color: #405bdf;
  font-weight: 800;
  /* outline: 1px solid red; */
  font-size: 1.4em;
  text-align: center;
}
.account {
  position: absolute;
  top: 40%;
  right: 16.5%;
  width: 28%;
}
.password {
  position: absolute;
  top: 52%;
  right: 16.5%;
  width: 28%;
}

.rememberBtn {
  position: absolute;
  bottom: 32%;
  right: 32%;
}
.loginBtn {
  position: absolute;
  bottom: 20%;
  right: 15.5%;
  width: 30%;
}
</style>